import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";

import * as componentTypes from "../../../constants/componentTypes";
import * as navigationActions from "../../../actions/navigationActions";
import * as rccActions from "../../../actions/rccActions";
import * as settings from "../../../constants/settings";
import * as config from "../../../constants/config";
import * as validationHelper from "../../../helpers/validationHelper";
import * as modelHelper from "../../../helpers/modelHelper";

import CloseButton from "../generic/CloseButton";
import Button from "../generic/Button";
import Modal from "../generic/Modal";

class DispensingQuickTintModal extends Component {
    handleCloseModalClick = () => {
        this.props.dispatchCloseDispensingQuickTintModalAction();
    };

    handlePrintButtonClick = () => {
        this.props.dispatchPrintFormulaAction(
            validationHelper.getPrinter(this.props.printerList, this.props.selectedPrinter),
            validationHelper.getValidItem(this.props.templateList, this.props.templateName),
            this.getFormulaObject(),
            this.props.unit,
            this.props.pos,
            this.props.clientIdentifier,
            this.props.printAsImage,
            this.props.loggedUser.login,
            this.props.tintometricSystem === null ? null : this.props.tintometricSystem.name
        );
    };

    getFormulaObject = () => {
        let formula = modelHelper.mapFormulaToObject(
            config.QUICK_TINT_ID,
            config.QUICK_TINT_ID,
            config.QUICK_TINT_NAME,
            translate("general.quickTint"),
            config.QUICK_TINT_NAME
        );
        if (this.props.unit === settings.UNIT_SHOT) {
            formula.colorantListShot = this.props.formula.colorantListShot;
            return formula.updateColorantsMlByShots(this.props.shotsCoef);
        }

        if (this.props.unit === settings.UNIT_G) {
            formula.colorantListG = this.props.formula.colorantListG;
            return formula.updateColorantsMlByG(this.props.shotsCoef);
        }

        formula.colorantList = this.props.formula.colorantList;

        return formula;
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                {(this.props.formula ? this.props.formula.getColorantListByUnit(this.props.unit) : []).map(
                    (colorant) => (
                        <div
                            id={colorant.id}
                            key={colorant.name}
                            className="width-100 flex font-2_5vh line-height-3_7vh std-border-bottom flex-space-between"
                        >
                            <div className="col-6 color-primary font-3_5vh flex flex-align-center-vertical padding-top-5 padding-bottom-5">
                                <div
                                    className="color-square"
                                    style={{backgroundColor: colorant.rgb, height: "2.5vh", width: "2.5vh"}}
                                />
                                <div>{colorant.displayName}</div>
                            </div>
                            <div className="flex flex-align-center-vertical">
                                {colorant.amount}&nbsp;{colorant.amountType}
                            </div>
                        </div>
                    )
                )}
            </React.Fragment>,
            "flex-column flex-child slim-scroll"
        );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <Button onClick={this.handlePrintButtonClick} label={<Translate value="general.print" />} />{" "}
                <CloseButton onClick={this.handleCloseModalClick} />
            </React.Fragment>,
            "flex-gap-10px slim-scroll"
        );
    };

    render() {
        return (
            <Modal
                modalId={this.props.id}
                header={modelHelper.buildModalSection(<Translate value="general.dispense" />)}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{
                    minWidth: "30%"
                }}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        formula: store.rcc.dispensingFormula ? store.rcc.dispensingFormula.formula : null,
        unit: store.settings.formulaUnits,
        canisterList: store.rcc.canisterList,
        selectedPrinter: store.settings.printer,
        printerList: store.rcc.printerList,
        templateName: store.settings.printerTemplateQuickTint,
        templateList: store.rcc.templateList,
        shotsCoef: store.settings.shotsCoef,
        pos: store.global.posInfo,
        clientIdentifier: store.module.clientIdentifier,
        printAsImage: store.settings.printAsImage,
        loggedUser: store.login.loggedUser,
        tintometricSystem: store.global.tintometricSystem
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseDispensingQuickTintModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.DISPENSING_QUICK_TINT_MODAL));
        },
        dispatchPrintFormulaAction: (
            printerName,
            template,
            formula,
            formulaUnits,
            pos,
            clientIdentifier,
            printAsImage,
            userName,
            tintometricSystem
        ) => {
            dispatch(
                rccActions.printFormulaFromQuickTint(
                    printerName,
                    template,
                    formula,
                    formulaUnits,
                    pos,
                    clientIdentifier,
                    printAsImage,
                    userName,
                    tintometricSystem
                )
            );
        }
    };
};

export default DispensingQuickTintModal = connect(mapStoreToProps, mapDispatchToProps)(DispensingQuickTintModal);
